import { lazy, Suspense, useEffect, useState } from "react";
import Loader from "../components/loaders/loader";
import { Route, Routes } from "react-router-dom";
import SplashScreen from "../components/splashScreen";
import SliderSkeleton from "../components/slider/simpleSlider/loader";

const Home = lazy(() => import("../features/home"));
const Destination = lazy(() => import("../features/destinations"));
const DestinationInfo = lazy(() => import("../features/destinations/destinationInfo"));
const Packages = lazy(() => import("../features/packagesList"));
const PackageDetails = lazy(() => import("../features/packageDetails"));
const BlogList = lazy(() => import("../features/websiteContent/blog"));
const BlogDetails = lazy(() => import("../features/websiteContent/blog/blogDetails"));
const AirportList = lazy(() => import("../features/destinations/airport"));
const AirportInfo = lazy(() => import("../features/destinations/airport/info"));
const ArticleList = lazy(() => import("../features/websiteContent/article"));
const ArticleDetails = lazy(() => import("../features/websiteContent/article/details"));
const About = lazy(() => import("../features/websiteContent/about"));
const VisaDocuments = lazy(() => import("../features/websiteContent/visaDocuments"));
const VisaDocumentsDetails = lazy(() => import("../features/websiteContent/visaDocuments/details"));
const FirstTravellers = lazy(() => import("../features/websiteContent/firstTravellers"));
const FirstTravellerDetails = lazy(() => import("../features/websiteContent/firstTravellers/details"));
const HealthMedical = lazy(() => import("../features/websiteContent/healthMedical"));
const HealthMedicalDetails = lazy(() => import("../features/websiteContent/healthMedical/details"));
const Contact = lazy(() => import("../features/contact"));
const AgentReview = lazy(() => import("../features/websiteContent/review"));
const AgentReviewDetails = lazy(() => import("../features/websiteContent/review/details"));
const Maintenance = lazy(() => import("../features/maintenancePage"));
const Registration = lazy(() => import("../features/agent/registration"));
const GroupWeddings = lazy(() => import("../features/websiteContent/groupWeddings"));
const WhatWeDo = lazy(() => import("../features/websiteContent/whatWeDo"));
const BookManage = lazy(() => import("../features/bookManage"));
const Careers = lazy(() => import("../features/websiteContent/careers"));
const PrivacyPolicy = lazy(() => import("../features/websiteContent/privacyPolicy"));
const Cookies = lazy(() => import("../features/websiteContent/cookies"));
const RefundPolicy = lazy(() => import("../features/websiteContent/refundPolicy"));
const TermsCondition = lazy(() => import("../features/websiteContent/termsCondition"));
const Disruption = lazy(() => import("../features/websiteContent/disruption"));
const Accessibility = lazy(() => import("../features/websiteContent/accessibility"));
const AgentsRights = lazy(() => import("../features/websiteContent/agentsRights"));
const NewsDetails = lazy(() => import("../features/home/news/details"));
const NewsRoom = lazy(() => import("../features/websiteContent/newsRoom"));
const NewsroomDetails = lazy(() => import("../features/websiteContent/newsRoom/details"));
const OurStrengths = lazy(() => import("../features/websiteContent/ourStrengths"));
const PageNotFound = lazy(() => import("../features/page-not-found"));

export default function Router({
    showLogin,
    setShowLogin
}: any) {
    const [loader, setLoader] = useState(true);
    useEffect(() => {
        setTimeout(() => {
            setLoader(false);
        }, 3000);
    }, []);

    return (
        <>
            {/* <Suspense fallback={<div><Loader /></div>}> */}
            <Suspense>
                <Routes>
                    <Route path="/" element={
                        <Suspense fallback={<SplashScreen />}>
                            <Suspense fallback={<SliderSkeleton />}>
                                {loader && <SliderSkeleton />}
                                <Home />
                            </Suspense>
                        </Suspense>
                    } />
                    <Route path='/home' element={<Home />} />
                    <Route path='/destination' element={<Destination />} />
                    <Route path='/destinationinfo/:decodeid' element={<DestinationInfo />} />
                    <Route path='/destinationinfo/:decodeid/:name' element={<DestinationInfo />} />
                    <Route path='/packages' element={<Packages />} />
                    <Route path='/packages/:decodeid' element={<Packages />} />
                    <Route path='/packages/:decodeid/:name' element={<Packages />} />
                    <Route path='/package/:decodeid' element={
                        <Suspense fallback={<SplashScreen />}>
                            <PackageDetails />
                        </Suspense>
                    } />
                    <Route path='/package/:decodeid/:name' element={
                        <Suspense fallback={<SplashScreen />}>
                            <PackageDetails />
                        </Suspense>
                    } />
                    <Route path='/blogs' element={<BlogList />} />
                    <Route path='/blogdetails/:decodeid' element={<BlogDetails />} />
                    <Route path='/blogdetails/:decodeid/:name' element={<BlogDetails />} />
                    <Route path='/airport' element={<AirportList />} />
                    <Route path='/airportInformation/:decodeid' element={<AirportInfo />} />
                    <Route path='/airportInformation/:decodeid/:name' element={<AirportInfo />} />
                    <Route path='/articles' element={<ArticleList />} />
                    <Route path='/articles/:decodeid' element={<ArticleList />} />
                    <Route path='/articleDetails/:decodeid' element={<ArticleDetails />} />
                    <Route path='/articleDetails/:decodeid/:name' element={<ArticleDetails />} />
                    <Route path='/about' element={<About />} />
                    <Route path='/visadocuments' element={<VisaDocuments />} />
                    <Route path='/visadocumentsdetails/:decodeid' element={<VisaDocumentsDetails />} />
                    <Route path='/visadocumentsdetails/:decodeid/:name' element={<VisaDocumentsDetails />} />
                    <Route path='/firstTravellers' element={<FirstTravellers />} />
                    <Route path='/firstTravellersdetails/:decodeid' element={<FirstTravellerDetails />} />
                    <Route path='/firstTravellersdetails/:decodeid/name' element={<FirstTravellerDetails />} />
                    <Route path='/healthMedical' element={<HealthMedical />} />
                    <Route path='/healthMedicalDetails/:decodeid' element={<HealthMedicalDetails />} />
                    <Route path='/healthMedicalDetails/:decodeid/:name' element={<HealthMedicalDetails />} />
                    <Route path='/contact' element={<Contact />} />
                    <Route path='/agentReview' element={<AgentReview />} />
                    <Route path='/agentreviewDetails/:decodeid' element={<AgentReviewDetails />} />
                    <Route path='/agentreviewDetails/:decodeid/:name' element={<AgentReviewDetails />} />
                    <Route path='/maintenance' element={<Maintenance />} />
                    <Route path='/registration' element={
                        <Registration
                            showLogin={showLogin}
                            setShowLogin={setShowLogin}
                        />
                    } />
                    <Route path='/groupWeddings' element={<GroupWeddings />} />
                    <Route path='/whatWeDo' element={<WhatWeDo />} />
                    <Route path='/whatWeDo/:decodeid/:name' element={<WhatWeDo />} />
                    <Route path='/bookManage' element={<BookManage />} />
                    <Route path='/careers' element={<Careers />} />
                    <Route path='/terms-condition' element={<TermsCondition />} />
                    <Route path='/privacy-policy' element={<PrivacyPolicy />} />
                    <Route path='/refund-policy' element={<RefundPolicy />} />
                    <Route path='/cookies' element={<Cookies />} />
                    <Route path='/disruption' element={<Disruption />} />
                    <Route path='/accessibility' element={<Accessibility />} />
                    <Route path='/agents-rights' element={<AgentsRights />} />
                    <Route path='/newsdetails/:decodeid' element={<NewsDetails />} />
                    <Route path='/newsdetails/:decodeid/:name' element={<NewsDetails />} />
                    <Route path='/newsroom' element={<NewsRoom />} />
                    <Route path='/newsroomdetails/:decodeid' element={<NewsroomDetails />} />
                    <Route path='/newsroomdetails/:decodeid/:name' element={<NewsroomDetails />} />
                    <Route path='/our-strengths' element={<OurStrengths />} />
                    <Route path='/our-strengths/:decodeid/:name' element={<OurStrengths />} />
                    <Route path="/not-found" element={<PageNotFound />} />
                    <Route path='*' element={<PageNotFound />} />

                </Routes>
            </Suspense>
        </>
    )
}